import React from 'react';

import IMG_READER from 'assets/images/pos/reader-connecting.png';
import AnimatedCircle from 'components/generic/AnimatedCircle.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './MessageOffline.module.scss';

const MessageConnecting = () => {
  const { t } = useTranslation();
  return (
    <div data-bem="MessageConnecting">
      <AnimatedCircle>
        <img src={IMG_READER} alt="POS reader with a card over it" className={CN.image} />
      </AnimatedCircle>
      <div className={CN.title}>{t('composite.posMessages.connecting')}</div>
    </div>
  );
};

// noinspection JSUnusedGlobalSymbols
export default MessageConnecting;
